import { useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { muiTheme } from "@/styles/theme";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import ResponsiveEditDialog from "@/modules/common/components/modals/responsive-edit-dialog";
import MonthlySummaryTable from "@/modules/targetsv2/components/targets-actions/actions/monthly-summary-table";
import { useTargetsMonthlyTargets } from "@/modules/targetsv2/hooks/monthly-summury.hook";
import { getQuarter } from "date-fns";

interface EditQuarterTargetFormProps {
  disabled?: boolean;
}

const MonthlySummary: React.FC<EditQuarterTargetFormProps> = ({ disabled }) => {
  const [open, setOpen] = useState(false);

  const { data, isLoading } = useTargetsMonthlyTargets();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  const { isMobile } = useScreenSize();

  const renderContent = () => {
    return (
      <ResponsiveEditDialog
        open={open}
        setOpen={handleClose}
        handleCloseModal={handleClose}
        header={`${new Date().getFullYear()} Q${getQuarter(
          new Date()
        )}, ${new Date().toLocaleString("default", { month: "long" })}`}
        hideModalFooter
        modalFooter={false}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: isMobile ? "100%" : "800px",
          }}
        >
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
              }}
            >
              <CircularProgress />
            </Box>
          ) : null}

          {data && !isLoading && <MonthlySummaryTable data={data} />}
        </Box>
      </ResponsiveEditDialog>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          padding: "10px 16px",
          alignItems: "center",
          justifyContent: "center",
          textWrap: "nowrap",
          width: "100%",
          height: "100%",
          cursor: disabled ? "not-allowed" : "pointer",
          ...muiTheme.typography.action_button,
          backgroundColor: disabled
            ? muiTheme.colorSchemes.light.palette.main.grey
            : muiTheme.colorSchemes.light.palette.main.actionDisabled,
          borderRadius: "8px",
          ":hover": disabled
            ? {}
            : {
                backgroundColor: muiTheme.colorSchemes.light.palette.main.grey,
              },
          opacity: 1,
        }}
        onClick={disabled ? () => {} : handleOpen}
      >
        <Typography
          sx={{
            color: "#015C9A",
          }}
          variant="action_button"
        >
          {isMobile ? "Month Summary" : "Team Monthly Summary"}
        </Typography>
      </Box>
      {renderContent()}
    </Box>
  );
};

export default MonthlySummary;
